import React from 'react';
import { Card, CardBody, CardHeader, Container, Row } from 'reactstrap';
import { Breadcrumbs, H5 } from '../../../AbstractElements';
import { CheckoutTitle } from '../../../Constant';
import CheckoutTableData from './CheckoutTableData';
import ProductPlaceOrder from './ProductPlaceOrder';

const CheckoutContainer = () => {
  return (
    <>
      <Container fluid={true} className='product-wrapper checkout'>
        <Breadcrumbs justify='end' pageTitle='Checkout' parent='Ecommerce' title='Checkout' />
        <Row>
          <Card>
            <CardHeader className='pb-0'>
              <H5>{CheckoutTitle}</H5>
            </CardHeader>
            <CardBody>
              <Row>
                <CheckoutTableData />
                <ProductPlaceOrder />
              </Row>
            </CardBody>
          </Card>
        </Row>
      </Container>
    </>
  );
};

export default CheckoutContainer;
